import React from "react";
import AdminCompanies from "../../../components/Dashboards/Admin/Home";
function AdminCompaniesPage() {
  return <AdminCompanies />;
}

export default AdminCompaniesPage;
